import { ReactNode, isValidElement } from 'react';

interface IProps {
  list: ReactNode[];
}

// Row of links separated by "|" pipes (rendered via :after on every item but the last).
const LinkPipeList = ({ list }: IProps) => (
  <div className="bcpipe">
    {list.map((item, index) => (
      <div data-name="link-item" key={isValidElement(item) ? item.key : index}>
        {item}
      </div>
    ))}
  </div>
);

export default LinkPipeList;
